export default __webpack_public_path__ + "static/media/boy2.ece5c080.svg";